// Run this example by adding <%= javascript_pack_tag 'hello_erb' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. Don't forget to uncomment erb tag after adding it to your layout file.

import '/tmp/build_d0ed85a4/vendor/bundle/ruby/2.6.0/gems/cocoon-1.2.14/app/assets/javascripts/cocoon.js';
import '/tmp/build_d0ed85a4/vendor/bundle/ruby/2.6.0/gems/rails-timeago-2.19.0/vendor/assets/javascripts/jquery.timeago.js';
